import { render, staticRenderFns } from "./solution-5.vue?vue&type=template&id=0a520c08&scoped=true&"
import script from "./solution-5.vue?vue&type=script&lang=js&"
export * from "./solution-5.vue?vue&type=script&lang=js&"
import style0 from "./solution-5.vue?vue&type=style&index=0&id=0a520c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a520c08",
  null
  
)

export default component.exports